/**
 * 存钱罐相关常量枚举
 */

/**
 * 领取状态枚举
 */
export enum GullakClaimStatus {
  /** 未领取 */
  NotClaimed = '0',
  /** 已领取 */
  Claimed = '1',
}

/**
 * 存钱罐状态枚举
 */
export enum GullakStatus {
  /** 开启 */
  Open = 1,
  /** 关闭 */
  Closed = 2,
}

/**
 * @des 转化状态
 */
export enum GullakTranslateStatusEnum {
  /** 开启 */
  Open = 1,
  /** 关闭 */
  Closed = 2,
}

/**
 * @des 指定转化率
 */
export enum GullakSpecialRateEnum {
  /** 开启 */
  Open = 1,
  /** 关闭 */
  Closed = 2,
}

/**
 * @des 前端可领取的最小金额
 */
export const MIN_CLAIMABLE_CASH = 1;